/* eslint-disable block-scoped-var */
/* eslint-disable sort-vars */
/* eslint-disable unicorn/prefer-string-slice */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-var */
/* eslint-disable vars-on-top */
/* eslint-disable no-undef */
/* eslint-disable prettier/prettier */
import { trackEvent } from '../../helpers/analytics';

export const inPageInitLibrary = (key) => {
  window.prodID = { a: [], c: 0, r: false, u: '' };
  window._lppr = (v) => {
    for (let index = 0; index < prodID.a.length; index++) {
      if (prodID.a[index].h === v) {
        return index;
      }
    }
  };
  window.prodID.a.push({ ckw: '', h: key });
  (function (index) {
    if (index && index.a.length > 0) {
      const c = document;
      const d = function d(e) {
        for (var a = 0, r = ''; a < e.length; a++) {
          r += String(e.charCodeAt(a).toString(16));
        }

        return r;
      };
      const v = function v(e) {
        for (
          var r = e.toString(), a = '', n = 0;
          n < r.length && '00' !== r.substr(n, 2);
          n += 2
        ) {
          a += String.fromCharCode(Number.parseInt(r.substr(n, 2), 16));
        }

        return a;
      };
      const u = function u() {
        for (let e = 0; e < index.a.length; e++) {
          const r = Math.floor(Date.now() / 1e3);
          let a = '';
          let n = '';
          if (index.a[e].ckw !== undefined) {
            n = index.a[e].ckw;
          }
          if (n.slice(-1) !== ';' && n.slice(-1) !== '') {
            n += ';';
          }
          if (index.a[e].k !== undefined) {
            a = 'kw=' + index.a[e].k + ';';
          }
          const t = a + n;
          const f =
            v(index.u) +
            '/' +
            r +
            '/' +
            s +
            '/' +
            l +
            '/' +
            window.atob(index.a[e].a) +
            '/' +
            index.b +
            '/' +
            index.c +
            '/' +
            d(t);
          const o = c.createElement('script');
          o.async = true;
          o.src = f;
          c.getElementById('w' + v(index.a[e].h)).appendChild(o);
        }
      };
      const f = function f() {
        let e = [];
        for (let r = 0; r < index.a.length; r++) {
          e.push(index.a[r].r);
        }
        if (e.includes(true) && index.hasOwnProperty('b')) {
          index.r = true;
        }
        e = [];
        if (index.r) {
          u();
        }
      };
      const a = function a() {
        function e() {
          if (c.querySelector('#Adwl') !== null) {
            index.b = 0;
          } else {
            index.b = 1;
          }
        }
        function r(e, r) {
          const a = c.querySelectorAll('body')[0];
          const n = c.createElement('script');
          n.src = v(e);
          if (typeof r !== 'undefined') {
            n.onload = r;
            n.onerror = r;
          }
          a.appendChild(n);
          o();
        }
        if (typeof e === 'function') {
          r(
            '68747470733a2f2f6433646835633772777a6c69776d2e636c6f756466726f6e742e6e65742f6164766572746973656d656e742e6a733f6466703d31',
            e,
          );
        }
      };
      var o = function o() {
        const e =
          '68747470733a2f2f643332313036726c6864636f676f2e636c6f756466726f6e742e6e65742f';
        let r = '';
        const a = Math.floor(Date.now() / 1e3);
        for (let n = 0; n < index.a.length; n++) {
          r += index.a[n].h;
          if (n < index.a.length - 1) {
            r += '/';
          }
        }
        const t = c.createElement('script');
        t.async = true;
        t.src = v(e) + a + '/' + s + '/' + l + '/' + r;
        t.onload = f;
        c.body.appendChild(t);
      };
      var l = '0';
      var s = '33';
      a();
    }
  })(
    (function () {
      const e = 'dDropI';
      const r = window[e[4] + e[2] + e[3] + e[0] + e[5] + e[1]];

      return typeof r !== undefined ? r : false;
    })(),
  );

  trackEvent('Webloyalty In Page Banner');
};
